import SosError, { IBaseSosErrorParamsWithDocs } from './SosError';

export interface IAppletErrorParams extends IBaseSosErrorParamsWithDocs {
	kind: 'appletError';
}

export default class AppletError extends SosError {
	constructor(parameters: IAppletErrorParams) {
		super({
			...parameters,
			kind: 'sosError',
		});
		this.name = 'AppletError';
	}
}
